import type { ReactNode } from "react";
import { useViewport } from "@/responsive/viewport";

/**
 * A page with a side panel (e.g. a file preview) docked to its right, full height; the page scrolls
 * on its own. On phones the panel covers the screen instead.
 */
export function WithSidePanel({ panel, children }: Readonly<{ panel?: ReactNode; children: ReactNode }>) {
  const { isMobile } = useViewport();
  return (
    <div className="relative flex h-full min-h-0">
      <div className="flex min-w-0 flex-1 flex-col overflow-y-auto">{children}</div>
      {panel && isMobile ? (
        <div className="fixed inset-0 z-40 overflow-hidden bg-surface-overlay pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
          {panel}
        </div>
      ) : (
        panel
      )}
    </div>
  );
}
